import { PrescriptionResponse } from '@ca/common'
import {
  getBase1FromValues,
  getBase2FromValues,
  getPrismLensPd,
} from '@screens/vision/prescription/form/calculateBase'
import {
  Label,
  ViewField as V,
} from '@screens/vision/prescription/form/components'
import {
  GAP,
  sButtonWrapper,
  sRow,
  WIDTH,
  WIDTH_SIDE,
} from '@screens/vision/prescription/form/styles'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface Props {
  data: PrescriptionResponse
}

export default function Prism(props: Props) {
  const { t } = useTranslation(['prescription'])
  const {
    r_prism1,
    l_prism1,
    r_prism2,
    l_prism2,
    right_na_te,
    left_na_te,
    right_ha_ba,
    left_ha_ba,
  } = props.data

  return (
    <View className="p-8" style={{ gap: GAP }}>
      <View className={sRow}>
        <View className={sButtonWrapper}>
          <Label width={WIDTH_SIDE} />
        </View>
        <Label width={2 * WIDTH + 1.5 * GAP + WIDTH_SIDE}>
          {t('prescription:horizontal', 'HORIZONTAL')}
        </Label>
        <Label width={2 * WIDTH + 1.5 * GAP + WIDTH_SIDE}>
          {t('prescription:vertical', 'VERTICAL')}
        </Label>
        <Label>BASE</Label>
        <Label>PRISM</Label>
        {/* <Label>{t('prescription:prism_pd', 'PRISM PD')}</Label> */}
      </View>
      <View className={sRow}>
        <View className={sButtonWrapper}>
          <Label width={WIDTH_SIDE} className="text-right">
            {t('prescription:r', 'R')}
          </Label>
        </View>
        <V>
          {right_na_te
            ? t(
                `prescription:${right_na_te.toLowerCase()}`,
                right_na_te.toUpperCase()
              )
            : ''}
        </V>
        <V>{r_prism1}</V>
        <V>
          {right_ha_ba
            ? t(
                `prescription:${right_ha_ba.toLowerCase()}`,
                right_ha_ba.toUpperCase()
              )
            : ''}
        </V>
        <V>{r_prism2}</V>
        <V fixed={false} disabled>{`${
          getBase1FromValues(props.data, 'r')?.toFixed(2) || '0'
        }°`}</V>
        <V disabled>{`${
          getBase2FromValues(props.data, 'r')?.toFixed(2) || '0.00'
        }`}</V>
        {/* <V>{`${getPrismLensPd(props.data, 'r') || '0.00'}`}</V> */}
      </View>
      <View className={sRow}>
        <View className={sButtonWrapper}>
          <Label width={WIDTH_SIDE} className="text-right">
            {t('prescription:l', 'L')}
          </Label>
        </View>
        <V>
          {left_na_te
            ? t(
                `prescription:${left_na_te.toLowerCase()}`,
                left_na_te.toUpperCase()
              )
            : ''}
        </V>
        <V>{l_prism1}</V>
        <V>
          {left_ha_ba
            ? t(
                `prescription:${left_ha_ba.toLowerCase()}`,
                left_ha_ba.toUpperCase()
              )
            : ''}
        </V>
        <V>{l_prism2}</V>
        <V fixed={false} disabled>{`${
          getBase1FromValues(props.data, 'l')?.toFixed(2) || '0'
        }°`}</V>
        <V disabled>{`${
          getBase2FromValues(props.data, 'l')?.toFixed(2) || '0.00'
        }`}</V>
        {/* <V>{`${getPrismLensPd(props.data, 'l') || '0.00'}`}</V> */}
      </View>
    </View>
  )
}
